
import { useStore } from '@/store'
import { defineComponent, inject } from 'vue'
import { computed } from 'vue'
import { FormActionTypes } from '@/store/modules/form/action-types'

export default defineComponent({
  name: 'NavbarSlider',
  props: {
    desktopTabs: {
      type: Array,
      default: []
    },
    mobileTabs: {
      type: Array,
      default: []
    }
  },
  setup() {
    const store = useStore()
    const currentTab = computed(() => store.getters.currentTab)
    const emitter: any = inject('emitter')

    const onPrevClick = () => {
      store.dispatch(FormActionTypes.SET_CURRENT_TAB, currentTab.value - 1)
    }

    const onNextClick = () => {
      store.dispatch(FormActionTypes.SET_CURRENT_TAB, currentTab.value + 1)
    }

    // const openBagsizeDialog = () => {
    //   emitter.emit('openBagsizeDialog')
    // }

    return {
      currentTab,
      onPrevClick,
      onNextClick,
      // openBagsizeDialog
    }
  }
})
